import { Typography, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import avatar from 'src/assets/images/technician.png';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  },
  imageContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 300,
    height: 'auto'
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }
}));

function Unauthorized() {
  const SessionUser = getUser();
  const classes = useStyles();
  const { t } = useTranslation('common');
  const renderSwitch = (param) => {
    switch (param) {
      case 1:
        return 'Sirius Technician';
      case 2:
        return 'Sirius ServiceShop';
      case 3:
        return 'Sirius CallCenter';
      case 4:
        return 'Sirius HeadOffice';
      case 5:
        return 'Sirius Admin';
      default:
        return 'Sirius ServiceShop';
    }
  }

  return (
    <Paper style={{ minHeight: 800, overflow: 'auto' }}>
      <br />
      <br />
      <br />
      <Typography align="center" variant={'h1'}>
        {t('lblUnauthorized')}
      </Typography>
      <div className={classes.imageContainer}>
        <img
          alt="Under development"
          className={classes.image}
          src={avatar}
        />

      </div>
      <br />
      <br />
      <Typography align="center" variant={'h5'}>
        {t('lblRoleLabel')}
        <b style={{ color: 'red' }}>{renderSwitch(SessionUser?.Role)}</b>
      </Typography>
      <br />
      <br />
      <br />
    </Paper>
  );
}

export default Unauthorized;
